import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNonNegative]'
})
export class NonNegativeDirective {
  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'Subtract') {
      event.preventDefault();
    }
  }

  // Covers paste, drag-drop and any other way of getting a minus sign into the field.
  @HostListener('input')
  onInput() {
    const input = this.el.nativeElement;
    const value = input.value;
    const isNegative = input.type === 'number' ? value.startsWith('-') : value.includes('-');
    if (!isNegative) {
      return;
    }
    input.value = value.replace(/-/g, '');
    // Re-notify the form control so it receives the sanitized value.
    input.dispatchEvent(new Event('input'));
  }
}
